// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__18_4V","itemTitle":"ClientEmergencyInfo_itemTitle__nyVu2","itemText":"ClientEmergencyInfo_itemText__1cHVy"};